import { render } from "./ReviewsCarousel.vue?vue&type=template&id=74879736&scoped=true"
import script from "./ReviewsCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewsCarousel.vue?vue&type=script&lang=js"

import "./ReviewsCarousel.vue?vue&type=style&index=0&id=74879736&scoped=true&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74879736"]])

export default __exports__